<p class="live-reconnect-hint" role="status" data-testid="live-reconnect-hint">
  <mat-icon aria-hidden="true">cloud_off</mat-icon>
  {{ messageKey() | translate: messageParams() }}
</p>
